import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import fithub from "../../assets/Projects/fithub.png";
import harwaqt from "../../assets/Projects/harwaqt.png";
import freeadcopy from "../../assets/Projects/freeadcopy.png";
import myiepbuddy from "../../assets/Projects/myiepbuddy.png";
import testify from "../../assets/Projects/testify.png";
import itsolve from "../../assets/Projects/itsolve.png";
import inventory from "../../assets/Projects/inventorysystem.png";
import patient from "../../assets/Projects/patientmobileapp.png";
import social from "../../assets/Projects/socialwebapp.png";
import firstegp from "../../assets/Projects/firstegp.png";
import ssr from "../../assets/Projects/ssr.png";
import parkingMate from "../../assets/Projects/parking-mate-website.png";
import healingInColor from "../../assets/Projects/healing-in-color-website.png";
import Particle from "../Particle";
import ProjectCard from "./ProjectCards";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="yellow">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={healingInColor}
              isGithub={false}
              title="Healing in Color"
              description="A scalable healthcare marketplace web app built as a full stack developer with Next.js, React, Node.js, Supabase, and PostgreSQL. Led frontend and backend development, including secure authentication, healthcare provider profiles, advanced search and filtering, booking workflows, REST API integrations, admin dashboards, and role-based access control. Optimized performance, database queries, and UX while keeping the architecture scalable, secure, and maintainable. Deployed to production as a reliable platform that connects providers with clients and supports long-term business growth."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={parkingMate}
              isGithub={false}
              title="ParkingMate Marketplace"
              description="A modern parking marketplace web app built as a full stack developer with Next.js, React, Node.js, and Stripe, connecting driveway owners with drivers to simplify parking space discovery, booking, and secure online payments. The platform is fast, scalable, and responsive, with a focus on performance, security, and an intuitive user experience. Features include parking space listing and management, interactive real-time maps, Stripe payments, booking and reservation management, a driver wallet and withdrawal system, user authentication with role-based access, and a responsive experience on desktop and mobile. It simplifies online booking, helps driveway owners earn passive income, and is designed as a production-ready Next.js application for long-term growth."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={ssr}
              isGithub={false}
              title="Sonic Scout Radio"
              description="A music streaming platform that connects independent artists with listeners through live radio broadcasts and music discovery. Built as a full stack developer with React Native, Expo, JavaScript, and Node.js API integration, Sonic Scout Radio delivers seamless streaming, artist promotion, and audience engagement. Features include live radio streaming, artist profiles, music uploads, push notifications, subscription plans, in-app payments via Stripe and RevenueCat, and tools that help artists grow their audience."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={freeadcopy}
              isGithub={false}
              title="FreeAdCopy"
              description="An AI-powered advertising copy generator that helps businesses create compelling ad copy quickly and efficiently. Built with React, Material-UI, and advanced AI technologies, FreeAdCopy generates high-quality marketing content for various platforms. Features include multiple ad formats, tone customization, industry-specific templates, and copy optimization suggestions to help businesses create effective advertising campaigns."
              demoLink="https://freeadcopy.com"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fithub}
              isGithub={false}
              title="FitHubs Mobile App"
              description="A comprehensive fitness mobile application built with React Native that helps users track their workouts, set fitness goals, and monitor their progress. Features include workout plans, exercise tracking, progress analytics, and social features to connect with other fitness enthusiasts. The app provides a seamless experience for users to maintain their fitness journey."
              ghLink="https:///mhamzashaikh/Bits-0f-C0de"
              demoLink="https://blogs.hamza.tech/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={firstegp}
              isGithub={false}
              title="FirstEGP"
              description="A real-time currency exchange rate platform built with Next.js that displays live currency rates for various currencies. FirstEGP features a comprehensive live rates system with data scraping capabilities and a custom API for fetching real-time exchange rates. The platform is fully bilingual, supporting both Arabic and English languages, making it accessible to a wide range of users. Features include live rate updates, currency conversion, historical rate tracking, and a responsive design optimized for both desktop and mobile devices."
              ghLink="https:///mhamzashaikh/AI_For_Social_Good"
              demoLink="https://firstegp.com"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={harwaqt}
              isGithub={false}
              title="HarWaqt"
              description="A modern time management and productivity web application built with React and modern web technologies. HarWaqt helps users efficiently manage their time, schedule tasks, and track productivity. Features include task scheduling, time tracking, productivity analytics, and reminders to help users stay organized and make the most of their time."
              ghLink="https:///mhamzashaikh/Bits-0f-C0de"
              demoLink="https://harwaqt.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={myiepbuddy}
              isGithub={false}
              title="MyIEPBuddy"
              description="An educational platform designed to help parents, teachers, and students manage Individualized Education Programs (IEPs). Built with modern web technologies, MyIEPBuddy provides tools for tracking student progress, managing IEP goals, scheduling meetings, and maintaining comprehensive records. The platform simplifies the IEP process and ensures better collaboration between all stakeholders in a student's education."
              ghLink="https:///mhamzashaikh/Bits-0f-C0de"
              demoLink="https://myiepbuddy.vercel.app"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={testify}
              isGithub={false}
              title="Testify"
              description="A comprehensive testing and assessment platform built with React and modern web technologies. Testify enables educators and organizations to create, manage, and conduct online tests and assessments. Features include question bank management, automated grading, detailed analytics, and secure test-taking environment. The platform streamlines the testing process and provides valuable insights into performance metrics."
              ghLink="https:///mhamzashaikh/Bits-0f-C0de"
              demoLink="https://testify-rouge.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={itsolve}
              isGithub={false}
              title="IT Solve"
              description="An IT support and ticketing management system built with React, Node.js, and MongoDB. IT Solve helps organizations efficiently manage IT support requests, track tickets, assign tasks to technicians, and monitor resolution times. Features include ticket creation, priority management, status tracking, knowledge base, and comprehensive reporting. The platform improves IT service delivery and enhances customer satisfaction."
              ghLink="https:///mhamzashaikh/Bits-0f-C0de"
              demoLink="https://itsolve.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={patient}
              isGithub={true}
              title="Patient Tracker Mobile App"
              description="The Patient Tracker App is a cross-platform mobile app built with React Native Expo and Firebase Realtime Database to help doctors manage patient records efficiently. With this app, doctors can easily enter and save patient details, search for patients by name or appointment date, and quickly access patient history whenever needed. It’s designed to streamline patient management and make the process smoother for healthcare professionals."
              ghLink="https:///mhamzashaikh/Editor.io"
              demoLink="https://editor.hamza.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={inventory}
              isGithub={true}
              title="Inventory Management System"
              description="The Inventory Management system is built using React JS, Node JS, Express JS, MongoDB, and Tailwind CSS. It’s designed to help businesses efficiently track, manage, and update their inventory with ease. The app provides a user-friendly interface for managing products, updating stock levels, and ensuring smooth operations—all while leveraging a powerful tech stack for optimal performance and scalability."
              ghLink="https:///mhamzashaikh/Plant_AI"
              demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={social}
              isGithub={true}
              title="Social Web"
              description="The MERN Social Media App is built with MongoDB, Express JS, React, and NodeJS. It allows users to connect, share, and engage with content seamlessly. The app leverages the power of the MERN stack to offer a smooth and dynamic social experience, with real-time updates, user interactions, and a robust backend for scalable performance."
              ghLink="https:///mhamzashaikh/Face_And_Emotion_Detection"
              demoLink="https://blogs.hamza.tech/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
